import { render, staticRenderFns } from "./Ranges.vue?vue&type=template&id=624a8662&scoped=true&lang=pug&"
import script from "./Ranges.vue?vue&type=script&lang=js&"
export * from "./Ranges.vue?vue&type=script&lang=js&"
import style0 from "./Ranges.vue?vue&type=style&index=0&id=624a8662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a8662",
  null
  
)

export default component.exports